import { render } from "./PhotoSection.vue?vue&type=template&id=3de99bbe&scoped=true"
const script = {}

import "./PhotoSection.vue?vue&type=style&index=0&id=3de99bbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de99bbe"]])

export default __exports__